// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V0GP","content":"styles_content__2c-LP","row":"styles_row__1na0d","footer":"styles_footer__1XS0_","phraseLength":"styles_phraseLength__3Yv42"};